import { useEffect, useMemo, useRef } from 'react';
import ReactDOM from 'react-dom';
import { usePortal } from '@polestar/component-warehouse-react/contexts/portal';
import { useIsSSR } from '@polestar/component-warehouse-react/contexts/ssr';
const Portal = ({ zIndex, insideContainer, flex = false, isFocusContainer, children, }) => {
    const previousContainerElement = useRef();
    const isSSR = useIsSSR();
    const { container, focusContainer } = usePortal();
    const parentContainer = isFocusContainer
        ? focusContainer
        : insideContainer !== undefined
            ? insideContainer
            : container;
    const containerElement = useMemo(() => {
        if (!isSSR) {
            const containerEl = (previousContainerElement === null || previousContainerElement === void 0 ? void 0 : previousContainerElement.current) || document.createElement('div');
            if (zIndex) {
                containerEl.style.zIndex = `${zIndex}`;
            }
            if (flex) {
                containerEl.style.width = `100vw`;
            }
            previousContainerElement.current = containerEl;
            return containerEl;
        }
    }, [flex, isSSR, zIndex]);
    // Cleanup div when we unmount
    useEffect(() => {
        const current = previousContainerElement.current;
        // this is needed here because in React Strict Mode otherwise it would not render portals because it is executed twice and the useEffect is triggered twice but not the useMemo
        if (parentContainer && current && !parentContainer.contains(current)) {
            if (parentContainer && current) {
                parentContainer === null || parentContainer === void 0 ? void 0 : parentContainer.appendChild(current);
            }
        }
        return () => {
            if (parentContainer && current && parentContainer.contains(current)) {
                parentContainer.removeChild(current);
            }
        };
    }, [parentContainer]);
    if (containerElement) {
        return ReactDOM.createPortal(children, containerElement);
    }
    return null;
};
export default Portal;
